import script from "./TenantSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./TenantSummaryView.vue?vue&type=style&index=0&id=4a562e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a562e0c"]])

export default __exports__